import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp-product-request-button',
  templateUrl: './lp-product-request-button.component.html',
  styleUrls: ['./lp-product-request-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpProductRequestButtonComponent {}
